































































































































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Meta } from "@/store/meta"
import { Vue, Component } from "vue-property-decorator"
import { Server, AccountInfo, ProfileInfo } from '@/store/server'
import { getModule } from "vuex-module-decorators"
import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber'
@Component({
})
export default class Account extends Vue {

  isProfileEditModalActive = false
  isOrganizationEditModalActive = false
  isWithdrawalModalActive = false
  isPasswordModalActive = false
  isLoading = false
  reason = ''

  loginInfo = getModule(Server).loginInfo

  profileForm: ProfileInfo = {
    name: '',
    name_furigana: '',
    phone_number: '',
  }
  organizationForm = {
    organization_name: '',
    organization_unit_name: '',
  }

  passwordForm = {
    // eslint-disable-next-line
    current_password: '',
    // eslint-disable-next-line
    new_password: '',
  }
  passwordConfirm = ''

  get meta() {
    return getModule(Meta)
  }
  get server() {
    return getModule(Server)
  }

  get loaded() {
    return !this.isLoading
  }

  get isOwner() {
    return this.meta.isOwner
  }

  get passwordConfirmMessage() {
    if (this.passwordConfirm.length === 0) return ''
    if (this.passwordConfirm !== this.passwordForm.new_password) {
      return '新しいパスワードと一致しません。'
    }
    return ''
  }

  get passwordAllow() {
    return this.passwordForm.current_password.length >= 8 &&
      this.passwordForm.new_password.length >= 8 &&
      this.passwordConfirm === this.passwordForm.new_password
  }

  async changePassword() {
    try {
      await getModule(Server).putMyPassword({
        // eslint-disable-next-line
        current_password: this.passwordForm.current_password,
        // eslint-disable-next-line
        new_password: this.passwordForm.new_password,
      })
      this.$buefy.toast.open({ message: 'パスワードを変更しました。', type: 'is-success' })
      this.closePasswordModal()
    } catch (error) {
      this.$buefy.toast.open({
        message: 'パスワード変更に失敗しました。現在のパスワードをご確認ください。',
        type: 'is-danger',
      })
    }
  }

  closePasswordModal() {
    this.isPasswordModalActive = false
    this.passwordForm = {
      // eslint-disable-next-line
      current_password: '',
      // eslint-disable-next-line
      new_password: '',
    }
    this.passwordConfirm = ''
  }

  async mounted() {
    this.isLoading = true
    await getModule(Server).getLoginInfo(this.accessToken)
    this.isLoading = false
  }

  get accessToken() {
    return this.meta.accessToken
  }

  profileEditModeIn() {
    this.profileForm = {
      name: this.loginInfo.name,
      name_furigana: this.loginInfo.name_furigana,
      phone_number: this.loginInfo.phone_number,
    }
    this.isProfileEditModalActive = true
  }

  organizationEditModeIn() {
    this.organizationForm = {
      organization_name: this.loginInfo.organization_name,
      organization_unit_name: this.loginInfo.organization_unit_name,
    }
    this.isOrganizationEditModalActive = true
  }

  async putProfile() {
    try {
      await getModule(Server).putMyProfile({
        name: this.profileForm.name,
        name_furigana: this.profileForm.name_furigana,
        phone_number: this.profileForm.phone_number,
      })
      this.$buefy.toast.open('個人情報を更新しました。')
      // 表示中の loginInfo にも反映 (再取得は不要)
      this.loginInfo.name = this.profileForm.name
      this.loginInfo.name_furigana = this.profileForm.name_furigana
      this.loginInfo.phone_number = this.profileForm.phone_number
    } catch (error) {
      this.$buefy.toast.open({
        message: '送信に失敗しました。大変お手数ですが、しばらくお待ちいただいた後に、再度送信をお願いします。',
        type: 'is-danger'
      })
    } finally {
      this.isProfileEditModalActive = false
    }
  }

  async putOrganization() {
    // PUT /v1/me は organization に加えて identity 系も @NotEmpty なので、現在値で埋めて送信。
    // organization_name / organization_unit_name のみが実質変更対象。
    const payload: AccountInfo = {
      name: this.loginInfo.name,
      name_furigana: this.loginInfo.name_furigana,
      email: this.loginInfo.email,
      organization_name: this.organizationForm.organization_name,
      organization_unit_name: this.organizationForm.organization_unit_name,
      phone_number: this.loginInfo.phone_number,
    }
    try {
      await getModule(Server).putLoginInfo(payload)
      this.$buefy.toast.open('組織情報を更新しました。')
      this.loginInfo.organization_name = this.organizationForm.organization_name
      this.loginInfo.organization_unit_name = this.organizationForm.organization_unit_name
    } catch (error) {
      this.$buefy.toast.open({
        message: '送信に失敗しました。大変お手数ですが、しばらくお待ちいただいた後に、再度送信をお願いします。',
        type: 'is-danger'
      })
    } finally {
      this.isOrganizationEditModalActive = false
    }
  }

  async accountWithdrawal() {
    try {
      await getModule(Server).accountWithdrawal(this.reason)
      this.$router.push({ path: 'account-withdrawal' })
    } catch (error) {
      this.$buefy.toast.open({
        message: '送信に失敗しました。',
        type: 'is-danger'
      })
    }
  }

  profileSendAllow() {
    return /^[ぁ-んー]*$/.test(this.profileForm.name_furigana) &&
      this.validationPhoneNumber(this.profileForm.phone_number) &&
      this.profileForm.name &&
      this.profileForm.name_furigana &&
      this.profileForm.phone_number
  }

  organizationSendAllow() {
    return !!(this.organizationForm.organization_name && this.organizationForm.organization_unit_name)
  }

  formatPhoneNumber(value: string) {
    if (value == undefined || value == '') return
    const phoneUtil = PhoneNumberUtil.getInstance()
    const PNF = PhoneNumberFormat
    const number = phoneUtil.parse(value, 'JP')
    const phoneNumber = phoneUtil.format(number, PNF.NATIONAL)
    return phoneNumber
  }

  validationPhoneNumber(value: string) {
    if (value == undefined || value == '' || isNaN(Number(value)) || /\s+/.test(value)) return false
    const phoneUtil = PhoneNumberUtil.getInstance()
    const number = phoneUtil.parse(value, 'JP')
    const isValid = phoneUtil.isValidNumber(number) as boolean
    return isValid
  }
}
